import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import { WarningCircle, ArrowSquareOut } from "@phosphor-icons/react";
import { money } from "@/lib/api";

const Box = ({ label, val }) => (
  <div className="bg-zinc-100 rounded-lg py-2">
    <p className="text-[10px] uppercase font-bold text-zinc-400">{label}</p>
    <p className="font-heading font-black text-zinc-900">{val}</p>
  </div>
);
const Row = ({ k, v }) => (
  <div className="flex justify-between text-sm"><span className="text-zinc-500">{k}</span><span className="font-medium text-zinc-800 capitalize text-right">{v || "—"}</span></div>
);

export const ResearchDrawer = ({ item, onClose }) => {
  const r = (item && item.research) || {};
  const unavailable = r.status === "unavailable";
  const host = (u) => { try { return new URL(u).hostname.replace("www.", ""); } catch { return u; } };
  return (
    <Drawer open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DrawerContent className="max-w-md mx-auto">
        <DrawerHeader><DrawerTitle className="font-heading">Pricing Research</DrawerTitle></DrawerHeader>
        <div className="px-4 pb-8 space-y-3 max-h-[72vh] overflow-y-auto" data-testid="research-drawer">
          {unavailable ? (
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-4" data-testid="research-unavailable">
              <div className="flex items-center gap-2 text-amber-700 font-bold"><WarningCircle size={20} weight="fill" /> LIVE PRICING RESEARCH UNAVAILABLE</div>
              <p className="text-sm text-amber-800 mt-1.5">{r.message || "Live market research could not be completed. Please enter a price manually or retry."}</p>
            </div>
          ) : (
            <>
              {r.explanation && <p className="text-sm text-zinc-700 leading-relaxed">{r.explanation}</p>}
              <div className="grid grid-cols-3 gap-2 text-center">
                <Box label="Low" val={money(r.low)} />
                <Box label="Typical" val={money(r.typical)} />
                <Box label="High" val={money(r.high)} />
              </div>
              <div className="bg-orange-50 rounded-xl p-3 flex items-center justify-between">
                <span className="text-xs font-bold uppercase text-orange-700">Recommended</span>
                <span className="font-heading font-black text-orange-600 text-xl" data-testid="research-recommended">{money(r.recommended)}</span>
              </div>
              <div className="space-y-1.5 border-t border-zinc-100 pt-3">
                <Row k="Price type" v={r.price_type} />
                <Row k="Pricing strategy" v={r.strategy} />
                <Row k="Area" v={r.area} />
                <Row k="Date researched" v={r.date_researched} />
              </div>
            </>
          )}
          {r.query && <p className="text-[11px] text-zinc-400">Search query: “{r.query}”</p>}
          <div>
            <p className="text-[10px] uppercase font-bold text-zinc-400 mb-1.5">
              Live sources{typeof r.source_count === "number" ? ` · ${r.source_count} used` : ""}{r.rejected_count ? ` · ${r.rejected_count} rejected` : ""}
            </p>
            <div className="space-y-1.5" data-testid="research-sources">
              {(r.sources || []).length === 0 && <p className="text-xs text-zinc-400">No sources recorded.</p>}
              {(r.sources || []).map((s, i) => (
                typeof s === "string"
                  ? <span key={i} className="inline-block text-[11px] bg-zinc-100 text-zinc-600 px-2 py-1 rounded-full mr-1.5">{s}</span>
                  : <a key={i} href={s.url} target="_blank" rel="noreferrer" data-testid={`research-source-${i}`}
                      className="flex items-start gap-1.5 text-[12px] text-blue-600 hover:underline">
                      <ArrowSquareOut size={14} className="mt-0.5 shrink-0" />
                      <span className="min-w-0"><span className="font-semibold">{host(s.url)}</span> — {s.title}</span>
                    </a>
              ))}
            </div>
          </div>
          {r.reasoning && (
            <div className="border-t border-zinc-100 pt-3">
              <p className="text-[10px] uppercase font-bold text-zinc-400 mb-1">Reasoning</p>
              <p className="text-sm text-zinc-600 leading-relaxed">{r.reasoning}</p>
            </div>
          )}
          <p className="text-[11px] text-zinc-400 pt-1">You can always override the recommended price on the job screen.</p>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
